import { FC, useState } from 'react';

const FallbackImage: FC<React.SVGProps<SVGSVGElement>> = () => {
    return (
        <svg viewBox="0 0 24 24" fill="#fcfdff" width="50px" height="50px">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-6h2v2h-2zm0-4h2v3h-2z" />
        </svg>
    );
};

type ImgProps = JSX.IntrinsicElements['img'] & {
    fallbackSrc?: string;
};

const ORIGINAL = 0;
const FIRST_FALLBACK = 1;
const LAST_CALLBACK = 2;

export const Img: FC<ImgProps> = props => {
    const { src, alt = 'image', fallbackSrc, ...rest } = props;
    const [sourceVersion, setSourceVersion] = useState(ORIGINAL);

    const handleError = () => {
        if (sourceVersion >= LAST_CALLBACK) return;
        setSourceVersion(prev => prev + 1);
    };

    if (sourceVersion === ORIGINAL) return <img src={src} alt={alt} onError={handleError} {...rest} />;
    if (sourceVersion === FIRST_FALLBACK && fallbackSrc) return <img src={fallbackSrc} alt={alt} onError={handleError} {...rest} />;

    return <FallbackImage />;
};
